<script setup>
import { ref, toRefs, watch, onMounted, nextTick } from "vue";
// import { stripe } from "/src/stripe.js";
import GoodsListDialog from "/src/components/molecules/GoodsListDialog.vue";
import MainAddCardDialog from "/src/components/molecules/MainAddCardDialog.vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import db from "/src/main.js";
import axios from "axios";
// import { is } from "@babel/types";
const props = defineProps({
  addresses: Array,
  cardsInfo: Array,
  goods_dialog: Boolean,
  goodsData: Array,
  orderId: String,
  error: String,
  isLoadingforcredit: Boolean,
  // isLoadingforpayment: Boolean,
  shippingFee: Number,
  totallPrice: Number,
  sumPrice: Number,
  defaultAddress: String,
  defaultCard: String,
  defaultpaymentmethod: String,
  goods_dialogaftercarrier: Boolean,
  user: String,
  vendorname_ja: String,
  campaignId: String, // クラウドファンディング用：プロジェクトID
  returnId: String, // クラウドファンディング用：リターンID（オプション、未指定の場合は選択画面を表示）
  crowdfundingSupportResult: Object, // クラウドファンディング用：支援結果
});

const emit = defineEmits([
  "goodsclose",
  "chooseGoods",
  "comfirmGoods",
  "getAddressData",
  "getCreditCard",
  "shippingfeeandorderprice",
  "comfirmGoodsforcarrierpayment",
  "comfirmGoodsforpaidy",
  "comfirmCrowdfundingSupport", // クラウドファンディング用：支援確定
  "crowdfundingSupportResult", // クラウドファンディング用：支援結果通知
]);
//  デフォルトの判定のためにカード情報と住所を呼び出す
emit("getCreditCard");
// emit("getAddressData");

const { isLoadingforcredit } = toRefs(props);
// const { isLoadingforpayment } = toRefs(props);
const { goods_dialogaftercarrier } = toRefs(props);
const { shippingFee } = toRefs(props);
const { totallPrice } = toRefs(props);
const { sumPrice } = toRefs(props);
const { defaultAddress } = toRefs(props);
const { defaultCard } = toRefs(props);
const { defaultpaymentmethod } = toRefs(props);
const { vendorname_ja } = toRefs(props);
const { error } = toRefs(props);
const { campaignId } = toRefs(props);
// returnIdはprops.returnIdとして直接使用するため、toRefsからは除外
const dialogclose = () => {
  fifthstep.value = false;
  sixstep.value = false;
  firststep.value = true;
  selectedReturn.value = null;
  emit("goodsclose");
};
const loadingforaddcardload = ref(false);
// const items = [1, 2, 3, 4, 5, 6];
const firststep = ref(true);
const secondstep = ref(false);
const selectnumber = ref(1);
const isSubmittingSupport = ref(false); // クラウドファンディング用：支援確定処理中フラグ
const choosebuycard = ref(null);

// クラウドファンディング用：リターン関連
const returnItems = ref([]);
const selectedReturn = ref(null);
const requiresShippingAddress = ref(false);
const isLoadingReturns = ref(false);
const supportMessage = ref(""); // 応援メッセージ
const expandedDescriptions = ref({}); // 説明文の展開状態を管理
// クラウドファンディング用：説明文の展開/折りたたみ
const toggleDescription = (returnId) => {
  expandedDescriptions.value[returnId] = !expandedDescriptions.value[returnId];
};

// クラウドファンディング用：リターンを選択
const selectReturn = (returnItem) => {
  selectedReturn.value = returnItem;
  requiresShippingAddress.value = returnItem.requiresShippingAddress || false;
  emit("getAddressData");
  firststep.value = false;
  loading.value = false; // ローディングを解除

  // 配送が必要な場合のみ住所選択へ、そうでなければ決済方法選択へ
  if (requiresShippingAddress.value) {
    //デフォルトがある場合、ここで分岐
    // デフォルトのクレジットカードがある場合、住所が1つでもあれば自動選択
    if (
      defaultpaymentmethod.value === "creditcard" &&
      defaultCard.value != null &&
      defaultCard.value !== "" &&
      addresses.value &&
      addresses.value.length > 0
    ) {
      fifthstep.value = true;
      useDefaultforCredit();
    } else if (defaultAddress.value && defaultpaymentmethod.value === "paidy") {
      fifthstep.value = true;
      useDefaultforPaidy();
    } else {
      // デフォルトがない場合は住所選択画面へ
      secondstep.value = true;
    }
  } else {
    // 配送が不要な場合
    // デフォルトのクレジットカードがある場合は住所選択をスキップして確認画面へ
    if (
      defaultpaymentmethod.value === "creditcard" &&
      defaultCard.value != null &&
      defaultCard.value !== ""
    ) {
      fifthstep.value = true;
      useDefaultforCredit();
    } else if (defaultpaymentmethod.value === "paidy") {
      // paidy決済の場合、デフォルト住所がある場合のみ確認画面へ、なければ住所選択画面へ
      if (defaultAddress.value) {
        fifthstep.value = true;
        useDefaultforPaidy();
      } else {
        // デフォルト住所がない場合は住所選択画面へ
        secondstep.value = true;
      }
    } else {
      // デフォルトがない場合は決済方法選択画面へ
      thirdstep.value = true;
    }
  }
};

// 従来のガチャ用（後方互換性のため残す）
const confirmgoods = async () => {
  emit("chooseGoods", selectnumber);
  emit("getAddressData");
  firststep.value = false;

  //デフォルトがある場合、ここで分岐
  if (
    defaultAddress.value &&
    defaultpaymentmethod.value === "creditcard" &&
    defaultCard.value != null
  ) {
    fifthstep.value = true;
    useDefaultforCredit();
    // emit("getAddressData");
  } else if (defaultAddress.value && defaultpaymentmethod.value === "paidy") {
    fifthstep.value = true;
    useDefaultforPaidy();
    // emit("getAddressData");
  }
  // else if (defaultAddress.value && defaultpaymentmethod.value === "carrier") {
  //   fifthstep.value = true;
  //   console.log("デフォルトがあるよーキャリア決済ー");
  //   useDefaultforCarrier();
  //   // emit("getAddressData");
  // }
  else {
    secondstep.value = true;
    // emit("getAddressData");
  }
};
const { orderId } = toRefs(props);
const { addresses } = toRefs(props);
const addresseslocal = ref(null);
const thirdstep = ref(false);
const chooseaddress = ref([]);
const paidyPaymentId = ref(null);
const toSelectPayment = (index) => {
  chooseaddress.value = addresses.value[index];
  // Paidy選択後に「住所を選択したらそのまま確認画面へ進む」ケース
  if (pendingPaidyAfterAddress.value) {
    pendingPaidyAfterAddress.value = false;
    secondstep.value = false;
    thirdstep.value = false;
    fifthstep.value = true;
    usepaidypaymentflag.value = true;
    loading.value = false; // ローディングを解除
  } else {
    secondstep.value = false;
    thirdstep.value = true;
    loading.value = false; // ローディングを解除
  }
};

// クラウドファンディング用：リターン情報を取得
const fetchReturnItems = async () => {
  if (!props.campaignId) {
    console.error("キャンペーンIDが指定されていません");
    return;
  }

  try {
    isLoadingReturns.value = true;
    const returnsCollection = collection(db, "Crowdfunding_projects", props.campaignId, "returns");
    const q = query(returnsCollection, where("isVisible", "==", true), orderBy("order", "asc"));
    const querySnapshot = await getDocs(q);

    returnItems.value = querySnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        title: data.title || "",
        price: data.price || 0,
        description: data.description || "",
        thumbUrl: data.thumbUrl || null,
        deliveryAt: data.deliveryAt || "",
        supporterCount: data.supporterCount || 0,
        isSoldOut: data.isSoldOut || false,
        requiresShippingAddress: data.requiresShippingAddress || false,
      };
    });

    // returnIdがpropsで指定されている場合は自動選択
    if (props.returnId) {
      const returnItem = returnItems.value.find((item) => item.id === props.returnId);
      if (returnItem) {
        selectedReturn.value = returnItem;
        requiresShippingAddress.value = returnItem.requiresShippingAddress || false;
      }
    }
  } catch (error) {
    console.error("リターンアイテム取得エラー:", error);
  } finally {
    isLoadingReturns.value = false;
  }
};
const loadingforaddress = ref(true);
watch(addresses, () => {
  addresseslocal.value = null;
  addresseslocal.value = addresses.value;
  loadingforaddress.value = false;
  // ここで任意のメソッドを呼び出す
});

const { cardsInfo } = toRefs(props);
const productsInfoLocal = ref(null);

watch(cardsInfo, () => {
  productsInfoLocal.value = null;
  productsInfoLocal.value = cardsInfo.value;
});

const fourthstep = ref(false);
const card = ref();
const cardId = ref();
const choosecard = ref([]);
const toComfirmOrderUsingCard = (index) => {
  card.value = cardsInfo.value[index];
  cardId.value = card.value.id;
  choosecard.value = cardsInfo.value[index];
  fourthstep.value = false;
  fifthstep.value = true;
  loading.value = false; // ローディングを解除
  // クラファンの場合は送料計算は不要
  if (!props.campaignId) {
    shippingfeeandorderprice();
  }
  // this.$router.push('/buy/comfirmOrder', () => {});
};
const GoodsListDialogflag = ref(false);

const openGoodsListDialog = () => {
  GoodsListDialogflag.value = true;
};
const sixstep = ref(false);
//本来ここで単価を計算するのは間違っている
const unitPrice = ref(null);
//本来ここで都道府県と市区町村と番地を確認し直すのは間違っている
const todohukenForPaidy = ref(null);
const cityForPaidy = ref(null);
const addressForPaidy = ref(null);
const addaddress2ForPaidy = ref(null);

//本来ここで郵便番号に-を入れるのは間違っている
const postCodeaddHyphenForPaidy = ref(null);

// クラウドファンディング用：支援確定
const comfirmCrowdfundingSupport = async () => {
  // 二重送信を防ぐ
  if (isSubmittingSupport.value) {
    return;
  }

  if (!selectedReturn.value || !props.campaignId) {
    console.error("リターンまたはキャンペーンIDが指定されていません");
    return;
  }

  // 処理開始時にフラグを立てる
  isSubmittingSupport.value = true;

  // paidy決済の場合、住所が必須（配送が必要な場合も不要な場合も）
  if (usepaidypaymentflag.value && !chooseaddress.value) {
    alert("あと払い（ペイディ）決済にはお届け先住所が必要です。住所を選択してください。");
    isSubmittingSupport.value = false; // バリデーションエラー時はフラグを戻す
    return;
  }

  // 配送が必要な場合、住所が選択されているかチェック
  if (requiresShippingAddress.value && !chooseaddress.value) {
    alert("お届け先住所を選択してください");
    isSubmittingSupport.value = false; // バリデーションエラー時はフラグを戻す
    return;
  }

  // 住所情報を取得（配送が必要な場合、またはpaidy決済の場合）
  let shippingAddress = null;
  if ((requiresShippingAddress.value || usepaidypaymentflag.value) && chooseaddress.value) {
    shippingAddress = {
      postcode: chooseaddress.value.postNumber || chooseaddress.value.postcode,
      address1: chooseaddress.value.address01 || chooseaddress.value.address1,
      address2: chooseaddress.value.address02 || chooseaddress.value.address2,
      name: chooseaddress.value.name,
      phoneno: chooseaddress.value.phoneNumber || chooseaddress.value.phoneno,
    };
  }

  if (usepaidypaymentflag.value) {
    // Paidy決済の場合
    fifthstep.value = false;

    // アカウント作成日
    const creationTime = props.user.metadata.creationTime;
    const date = new Date(creationTime);
    const formattedDate = `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${(
      "0" + date.getDate()
    ).slice(-2)}`;

    const functions = getFunctions(undefined, "asia-northeast1");
    const calculateChOrderStats = httpsCallable(functions, "calculateChOrderStats");
    const order_count = ref(0);
    const ltv = ref(0);
    const last_order_at = ref(0);
    const last_order_amount = ref(0);

    try {
      const result = await calculateChOrderStats();
      order_count.value = result.data.chOrderCount;
      ltv.value = result.data.lifetimeValue;
      last_order_at.value = result.data.daysSinceLastOrder;
      last_order_amount.value = result.data.lastOrderAmount;
    } catch (error) {
      console.error("エラーが発生しました:", error);
      isSubmittingSupport.value = false; // エラー時はフラグを戻す
      return;
    }

    const paidypublickkey = process.env.VUE_APP_PAIDY_PUBLIC_KEY;
    var config = {
      api_key: paidypublickkey,
      closed: function (callbackData) {
        if (callbackData.status === "authorized") {
          paidyPaymentId.value = callbackData.id;
          emit("comfirmCrowdfundingSupport", {
            campaignId: props.campaignId,
            returnId: selectedReturn.value.id,
            amount: selectedReturn.value.price,
            paymentMethod: "paidy",
            paidyPaymentId: paidyPaymentId.value,
            message: supportMessage.value,
            shippingAddress: shippingAddress,
          });
          fifthstep.value = false;
          sixstep.value = true;
          // Paidy決済成功時はフラグを戻す（完了画面に遷移したので）
          isSubmittingSupport.value = false;
        } else {
          sixstep.value = true;
          paidyfronterror.value = true;
          fifthstep.value = true;
          sixstep.value = false;
          // Paidy決済失敗時はフラグを戻す（再度試せるように）
          isSubmittingSupport.value = false;
        }
      },
    };

    const paidyHandler = window.Paidy.configure(config);
    var payload = {
      amount: selectedReturn.value.price,
      currency: "JPY",
      store_name: "SukiSukiらいぶすてーしょん",
      buyer: {
        email: props.user.email,
        name1: shippingAddress ? shippingAddress.name : props.user.displayName || "ユーザー",
      },
      buyer_data: {
        account_registration_date: formattedDate,
        ltv: ltv.value,
        order_count: order_count.value,
        last_order_amount: last_order_amount.value,
        last_order_at: last_order_at.value,
      },
      order: {
        items: [
          {
            quantity: 1,
            title: selectedReturn.value.title || selectedReturn.value.name,
            unit_price: selectedReturn.value.price,
          },
        ],
      },
    };

    // paidy決済の場合、住所は常に必要（配送が必要な場合も不要な場合も）
    if (shippingAddress) {
      splitAddress(shippingAddress.address1, shippingAddress.address2);
      postCodeaddHyphenForPaidy.value =
        shippingAddress.postcode.toString().slice(0, 3) +
        "-" +
        shippingAddress.postcode.toString().slice(3);
      payload.shipping_address = {
        line1: addaddress2ForPaidy.value || shippingAddress.address2,
        line2: addressForPaidy.value || shippingAddress.address1,
        city: cityForPaidy.value,
        state: todohukenForPaidy.value,
        zip: postCodeaddHyphenForPaidy.value,
      };
    } else {
      // 住所がない場合はエラー（この時点でshippingAddressはnullのはずだが、念のため）
      console.error("Paidy決済には住所が必要です");
      alert("あと払い（ペイディ）決済にはお届け先住所が必要です。");
      isSubmittingSupport.value = false;
      return;
    }

    paidyHandler.launch(payload);
  } else {
    // クレジットカード決済の場合
    // 決済処理を開始（画面遷移は結果を待ってから）
    const supportData = {
      campaignId: props.campaignId,
      returnId: selectedReturn.value.id,
      amount: selectedReturn.value.price,
      paymentMethod: "creditcard",
      cardId: cardId.value,
      message: supportMessage.value,
      shippingAddress: shippingAddress,
    };

    // emitで親コンポーネントに処理を依頼（結果は別のemitで受け取る）
    emit("comfirmCrowdfundingSupport", supportData);
    // 画面遷移はcrowdfundingSupportResultイベントで制御
    // 注意: 成功時は画面遷移時にフラグを戻す、エラー時はwatch(error)で戻す
  }
};

// 従来のガチャ用（後方互換性のため残す）
const comfirmBuy = async () => {
  if (usecarrierpaymentflag.value) {
    emit("comfirmGoodsforcarrierpayment", selectnumber, choosebuycard, chooseaddress, cardId);
    fifthstep.value = false;
    sixstep.value = true;
  } else if (usepaidypaymentflag.value) {
    // フラグを更新してUIを変更
    fifthstep.value = false;
    // 本来ここで単価を計算するのは間違っている
    unitPrice.value = (totallPrice.value - shippingFee.value) / selectnumber.value;
    // 本来ここで都道府県を確認し直すのは間違っている
    splitAddress(chooseaddress.value.address01, chooseaddress.value.address02);

    // 本来ここで郵便番号に-を入れるのは間違っている
    postCodeaddHyphenForPaidy.value =
      chooseaddress.value.postNumber.toString().slice(0, 3) +
      "-" +
      chooseaddress.value.postNumber.toString().slice(3);

    // アカウント作成日
    const creationTime = props.user.metadata.creationTime; // "2020-10-25T12:34:56Z" 形式
    const date = new Date(creationTime); // Dateオブジェクトに変換

    // "2020-10-25" の形式に変換
    const formattedDate = `${date.getFullYear()} - ${("0" + (date.getMonth() + 1)).slice(-2)} - ${(
      "0" + date.getDate()
    ).slice(-2)}`;

    const itemName = vendorname_ja.value + "限定グッズ";

    // 本来親で呼び出すべき
    const functions = getFunctions(undefined, "asia-northeast1");
    const calculateChOrderStats = httpsCallable(functions, "calculateChOrderStats");
    const order_count = ref(0);
    const ltv = ref(0);
    const last_order_at = ref(0);
    const last_order_amount = ref(0);

    // 非同期処理の完了を待つ
    try {
      const result = await calculateChOrderStats();
      order_count.value = result.data.chOrderCount;
      ltv.value = result.data.lifetimeValue;
      last_order_at.value = result.data.daysSinceLastOrder;
      last_order_amount.value = result.data.lastOrderAmount;
    } catch (error) {
      console.error("エラーが発生しました:", error);
      return; // エラーが発生した場合は処理を中断
    }
    const paidypublickkey = process.env.VUE_APP_PAIDY_PUBLIC_KEY;
    var config = {
      api_key: paidypublickkey,
      closed: function (callbackData) {
        if (callbackData.status === "authorized") {
          // 支払いが承認されたらPayment IDを取得
          paidyPaymentId.value = callbackData.id;

          // Paidy Payment IDを使って次のステップに進む
          emit("comfirmGoodsforpaidy", selectnumber, chooseaddress, paidyPaymentId.value);
          // フラグを更新してUIを変更
          fifthstep.value = false;
          sixstep.value = true;
        } else {
          sixstep.value = true;
          paidyfronterror.value = true;
          fifthstep.value = true;
          sixstep.value = false;
        }
      },
    };

    const paidyHandler = window.Paidy.configure(config);
    // email: props.user.email,
    // email: "successful.payment@paidy.com",
    var payload = {
      amount: totallPrice.value,
      currency: "JPY",
      store_name: "SukiSukiらいぶすてーしょん",
      buyer: {
        email: props.user.email,
        name1: chooseaddress.value.name,
      },
      buyer_data: {
        account_registration_date: formattedDate,
        ltv: ltv.value,
        order_count: order_count.value,
        last_order_amount: last_order_amount.value,
        last_order_at: last_order_at.value,
      },
      order: {
        items: [
          {
            quantity: selectnumber.value,
            title: itemName,
            unit_price: unitPrice.value,
          },
        ],
        shipping: shippingFee.value,
      },
      shipping_address: {
        line1: addaddress2ForPaidy.value,
        line2: addressForPaidy.value,
        city: cityForPaidy.value,
        state: todohukenForPaidy.value,
        zip: postCodeaddHyphenForPaidy.value,
      },
    };
    // Paidy Checkoutを起動
    paidyHandler.launch(payload);
  } else {
    emit("comfirmGoods", selectnumber, choosebuycard, chooseaddress, cardId.value);
    fifthstep.value = false;
    sixstep.value = true;
  }
};

async function splitAddress(fullAddress, address2) {
  if (!address2) {
    addaddress2ForPaidy.value = "";
  } else {
    addaddress2ForPaidy.value = address2;
  }

  // 日本の都道府県のリスト
  const prefectures = [
    "北海道",
    "青森県",
    "岩手県",
    "宮城県",
    "秋田県",
    "山形県",
    "福島県",
    "茨城県",
    "栃木県",
    "群馬県",
    "埼玉県",
    "千葉県",
    "東京都",
    "神奈川県",
    "新潟県",
    "富山県",
    "石川県",
    "福井県",
    "山梨県",
    "長野県",
    "岐阜県",
    "静岡県",
    "愛知県",
    "三重県",
    "滋賀県",
    "京都府",
    "大阪府",
    "兵庫県",
    "奈良県",
    "和歌山県",
    "鳥取県",
    "島根県",
    "岡山県",
    "広島県",
    "山口県",
    "徳島県",
    "香川県",
    "愛媛県",
    "高知県",
    "福岡県",
    "佐賀県",
    "長崎県",
    "熊本県",
    "大分県",
    "宮崎県",
    "鹿児島県",
    "沖縄県",
  ];

  // 都道府県を抽出
  for (const prefecture of prefectures) {
    if (fullAddress.startsWith(prefecture)) {
      todohukenForPaidy.value = prefecture;
      // 残りの住所を取得
      fullAddress = fullAddress.slice(prefecture.length).trim();
      break;
    }
  }

  // 市区町村と番地を分割
  const cityIndex = fullAddress.search(/[市区町村郡]/);
  if (cityIndex !== -1) {
    cityForPaidy.value = fullAddress.slice(0, cityIndex + 1).trim();
    addressForPaidy.value = fullAddress.slice(cityIndex + 1).trim();
  } else {
    // 市区町村が見つからなかった場合は、すべてを番地として扱う
    cityForPaidy.value = "";
    addressForPaidy.value = fullAddress;
  }

  return {};
}

const returnsteps = (steps) => {
  if (steps == 2) {
    secondstep.value = false;
    firststep.value = true;
  } else if (steps == 2.5) {
    nextsecondstep.value = false;
    secondstep.value = true;
  } else if (steps == 3) {
    emit("getAddressData");
    thirdstep.value = false;
    // クラウドファンディングで配送が必要な場合は住所選択に戻る、不要な場合はリターン選択に戻る
    if (props.campaignId) {
      if (requiresShippingAddress.value) {
        secondstep.value = true;
      } else {
        firststep.value = true;
      }
    } else {
      secondstep.value = true;
    }
  } else if (steps == 4) {
    fourthstep.value = false;
    thirdstep.value = true;
  } else if (steps == 5) {
    fourthstep.value = true;
    fifthstep.value = false;
  } else if (steps == 6) {
    usepaidypaymentflag.value = false;
    carderror.value = false;
    paidyfronterror.value = false;
    fifthstep.value = false;
    // クラウドファンディングで配送が必要な場合は住所選択に戻る、不要な場合は決済方法選択に戻る
    if (props.campaignId) {
      if (requiresShippingAddress.value) {
        secondstep.value = true;
      } else {
        thirdstep.value = true;
      }
    } else {
      thirdstep.value = true;
    }
  }
};
const selectCreditCardPayment = () => {
  thirdstep.value = false;
  fourthstep.value = true;
  loading.value = false; // ローディングを解除
  // emit("getCreditCard");
};
const selectPaidyPayment = () => {
  // クラファンの場合は送料計算は不要
  if (!props.campaignId) {
    emit("shippingfeeandorderprice");
  }
  // paidy決済の場合、住所が選択されていない場合は住所選択画面へ
  if (
    !chooseaddress.value ||
    (Array.isArray(chooseaddress.value) && chooseaddress.value.length === 0)
  ) {
    // 住所選択後にそのままpaidy確認画面へ進むためのフラグ
    pendingPaidyAfterAddress.value = true;
    thirdstep.value = false;
    secondstep.value = true;
    loading.value = false; // ローディングを解除
  } else {
    thirdstep.value = false;
    fifthstep.value = true;
    usepaidypaymentflag.value = true;
    loading.value = false; // ローディングを解除
  }
  // emit("getCreditCard");
};
const usecarrierpaymentflag = ref(false);
const usepaidypaymentflag = ref(false);
// Paidy選択後に住所選択を挟んだ場合に、支払い方法選択画面を挟まず
// 直接確認画面へ遷移させるためのフラグ
const pendingPaidyAfterAddress = ref(false);
const changeAddress = () => {
  emit("getAddressData");
  chooseaddress.value = [];
  // 確認画面でpaidy利用中に住所を変更した場合、
  // 住所選択後は支払い方法選択を挟まず直接確認画面に戻す
  if (usepaidypaymentflag.value) {
    pendingPaidyAfterAddress.value = true;
  }
  fifthstep.value = false;
  secondstep.value = true;
};
const fifthstep = ref(false);
const changePayment = () => {
  usepaidypaymentflag.value = false;
  carderror.value = false;
  paidyfronterror.value = false;
  usecarrierpaymentflag.value = false;
  choosecard.value = [];
  cardId.value = null;
  fifthstep.value = false;
  thirdstep.value = true;
};

const goodslistdialogclose = () => {
  GoodsListDialogflag.value = false;
};
const nextsecondstep = ref(false);

const toAddAddress = () => {
  secondstep.value = false;
  nextsecondstep.value = true;
};
//アドレス追加用
const jsonpAdapter = require("axios-jsonp");

const postcode = ref(null);
const todohuken = ref(null);
const moreaddress = ref(null);
const address1 = ref(null);
const address2 = ref(null);
const familyname = ref("");
const firstname = ref("");
const name = ref(null);
const phoneno = ref(null);
const postcodeError = ref(null);

const getaddressfrompostcode = () => {
  const apiURL = "https://api.zipaddress.net/?zipcode=" + postcode.value;

  if (!postcode.value || postcode.value.toString().length != 7) {
    postcodeError.value = "郵便番号はハイフンなしの7桁で入力してください。";
  } else {
    postcodeError.value = null;
  }

  axios.get(apiURL, { adapter: jsonpAdapter }).then(async (res) => {
    const response = res.data;
    todohuken.value = response.pref;
    if (response.city) {
      todohuken.value = response.pref;
      moreaddress.value = response.city + response.town;
    } else {
      console.log("郵便番号間違い");
    }
  });
};

const phoneError = ref(null);
const checkphoneno = () => {
  if (!phoneno.value || phoneno.value.toString().length < 9) {
    phoneError.value = "電話番号を入力してください。";
  } else {
    phoneError.value = null;
  }
};

const sendaddress = async () => {
  address1.value = todohuken.value + moreaddress.value;
  name.value = familyname.value + " " + firstname.value;
  emit("sendaddress", postcode, address1, address2, name, phoneno);
  // emit("getAddressData");

  nextsecondstep.value = false;
  secondstep.value = true;
  loadingforaddress.value = true;
};

// クラウドファンディングの場合はGoods_getOrderProductsは不要
// 従来のガチャ用の変数（クラウドファンディングでは使用しない）
const order = ref(null);
const dataLenght = ref();
const isDeclinePayment = ref(false);
const videoplayflag = ref(true);
const showimageflag = ref(false);
const productindex = ref(0);
const allproductsflag = ref(false);
const loadingForOrder = ref(true);
const isLoadingforvideo = ref(true);
const gachaVideoUrlA = ref(process.env.VUE_APP_GCS_URL + "/live_station_images_common/video_A.mp4");
const gachaVideoUrlB = ref(process.env.VUE_APP_GCS_URL + "/live_station_images_common/video_B.mp4");
const gachaVideoUrlC = ref(process.env.VUE_APP_GCS_URL + "/live_station_images_common/video_C.mp4");

// 従来のガチャ用の関数（クラウドファンディングでは使用しない）
const getOrderinfo = async () => {
  // クラウドファンディングの場合はスキップ
  if (props.campaignId) {
    return;
  }
  if (orderId.value != "undefined") {
    const functions = getFunctions();
    functions.region = "asia-northeast1";
    const addMessage = httpsCallable(functions, "Goods_getOrderProducts");
    addMessage({ text: orderId.value }).then((result) => {
      order.value = result.data;
      dataLenght.value = result.data.length - 1;
    });
  } else {
    isDeclinePayment.value = true;
  }
};

const videoend = () => {
  videoplayflag.value = false;
  showimageflag.value = true;
};

const nextproduct = () => {
  productindex.value += 1;
  showimageflag.value = false;
  videoplayflag.value = true;
};

const toAllproducts = () => {
  showimageflag.value = false;
  videoplayflag.value = false;
  allproductsflag.value = true;
};

const handleLoadedData = () => {
  isLoadingforvideo.value = false;
};

const handlePlay = () => {};

watch(orderId, () => {
  // クラウドファンディングの場合はスキップ
  if (props.campaignId) {
    return;
  }
  carderror.value = false;
  getOrderinfo();
});

watch(order, (newValue) => {
  if (newValue === null) {
    loadingForOrder.value = true;
  } else {
    loadingForOrder.value = false;
  }
});
const carderror = ref(false);
const paidyfronterror = ref(false);
// error を監視
watch(error, () => {
  sixstep.value = false;
  fifthstep.value = true;
  carderror.value = true;
  // エラー時は支援確定処理フラグを戻す
  if (props.campaignId) {
    isSubmittingSupport.value = false;
  }
});

// クラウドファンディング用：支援結果を監視
watch(
  () => props.crowdfundingSupportResult,
  (result) => {
    if (result) {
      if (result.success) {
        // 決済が成功した場合のみ完了画面に遷移
        fifthstep.value = false;
        sixstep.value = true;
        // 成功時はフラグを戻す（完了画面に遷移したので）
        isSubmittingSupport.value = false;
      } else {
        // エラーの場合は確認画面に留まる（エラーはwatch(error)で表示される）
        // fifthstepは既にtrueのまま
        // エラー時はフラグを戻す（再度試せるように）
        isSubmittingSupport.value = false;
      }
    }
  }
);

//クレジットカード追加
const nextfourthstep = ref(false);
const toAddCard = () => {
  nextfourthstep.value = true;
  fourthstep.value = false;
};
const addcardclose = () => {
  emit("getCreditCard");
  nextfourthstep.value = false;
  fourthstep.value = true;
};

//stripeの影響で子のコンポーネントでロード画面が動かないためここに実装
const addcardload = () => {
  loadingforaddcardload.value = true;
};
//stripeの影響で子のコンポーネントでロード画面が動かないための実装 カード登録に失敗した場合ロードを消す
const addcardloadoff = () => {
  loadingforaddcardload.value = false;
};
const shippingfeeandorderprice = () => {
  emit("shippingfeeandorderprice");
};
//デフォルトの場合（クレジット）
const useDefaultforCredit = async () => {
  // 配送が必要な場合のみ住所を設定
  if (props.campaignId && requiresShippingAddress.value) {
    // デフォルトの住所がある場合はそれを使用、なければ最初の住所を使用
    if (defaultAddress.value) {
      chooseaddress.value = addresses.value.find(
        (address) => address.addressId == defaultAddress.value
      );
    } else if (addresses.value && addresses.value.length > 0) {
      // デフォルトの住所がない場合は最初の住所を使用
      chooseaddress.value = addresses.value[0];
    }
  } else if (!props.campaignId) {
    // 従来のガチャの場合は常に住所を設定
    if (defaultAddress.value) {
      chooseaddress.value = addresses.value.find(
        (address) => address.addressId == defaultAddress.value
      );
    } else if (addresses.value && addresses.value.length > 0) {
      // デフォルトの住所がない場合は最初の住所を使用
      chooseaddress.value = addresses.value[0];
    }
  }
  choosecard.value = cardsInfo.value.find((card) => card.id == defaultCard.value);
  cardId.value = choosecard.value.id;
  loading.value = false; // ローディングを解除
  // クラファンの場合は送料計算は不要
  if (!props.campaignId) {
    await shippingfeeandorderprice();
  }
};
//デフォルトの場合（paidy）
const useDefaultforPaidy = async () => {
  // paidy決済の場合、住所は常に必要（配送が必要な場合も不要な場合も）
  if (props.campaignId) {
    // クラウドファンディングの場合、配送が必要な場合も不要な場合も住所を設定
    chooseaddress.value = addresses.value.find(
      (address) => address.addressId == defaultAddress.value
    );
  } else if (!props.campaignId) {
    // 従来のガチャの場合は常に住所を設定
    chooseaddress.value = addresses.value.find(
      (address) => address.addressId == defaultAddress.value
    );
  }
  usepaidypaymentflag.value = true;
  loading.value = false; // ローディングを解除
  // クラファンの場合は送料計算は不要
  if (!props.campaignId) {
    await shippingfeeandorderprice();
  }
};
//デフォルトの場合（キャリア）
// const useDefaultforCarrier = async () => {
//   console.log(addresses.value);
//   console.log(defaultAddress);
//   chooseaddress.value = addresses.value.find(
//     (address) => address.addressId == defaultAddress.value
//   );
//   usecarrierpaymentflag.value = true;
//   await shippingfeeandorderprice();
// };

// モーダル内のスクロール位置を一番上にリセット
const modalInnerRef = ref(null);
const resetModalScroll = () => {
  nextTick(() => {
    // refで直接アクセス
    if (modalInnerRef.value) {
      modalInnerRef.value.scrollTop = 0;
      modalInnerRef.value.scrollTo({ top: 0, behavior: "instant" });
    }
    // 念のため、テレポートされた要素も検索
    setTimeout(() => {
      const modalInner = document.querySelector("body > .modal .inner");
      if (modalInner) {
        modalInner.scrollTop = 0;
        modalInner.scrollTo({ top: 0, behavior: "instant" });
      }
      const modalInnerAlt = document.querySelector(".modal .inner");
      if (modalInnerAlt) {
        modalInnerAlt.scrollTop = 0;
        modalInnerAlt.scrollTo({ top: 0, behavior: "instant" });
      }
    }, 50);
  });
};

// goods_dialogが開いた時にスクロールをリセット
watch(
  () => props.goods_dialog,
  (newValue) => {
    if (newValue) {
      // 少し遅延を入れて確実に要素が存在するようにする
      setTimeout(() => {
        resetModalScroll();
      }, 100);
    }
  },
  { immediate: true }
);

// firststepがtrueになった時（リターン選択画面に戻った時）もスクロールをリセット
watch(firststep, (newValue) => {
  if (newValue && props.goods_dialog) {
    setTimeout(() => {
      resetModalScroll();
    }, 100);
  }
});

// 各ステップが変わる時にもスクロールをリセット
watch([secondstep, thirdstep, fourthstep, fifthstep, sixstep], () => {
  if (props.goods_dialog) {
    setTimeout(() => {
      resetModalScroll();
    }, 100);
  }
});

onMounted(() => {
  if (goods_dialogaftercarrier.value == true) {
    firststep.value = false;
    sixstep.value = true;
  }

  // クラウドファンディング用：リターン情報を取得
  if (props.campaignId) {
    fetchReturnItems();
  }
});
const loading = ref(true);
watch(
  () => totallPrice.value,
  (newTotalPrice) => {
    // totallPriceの値が変更されたときに実行される処理
    console.log(newTotalPrice);
    loading.value = false;
  }
);

//＋ーで商品数を変更
const incrementSelectNumber = () => {
  selectnumber.value++;
};

const decrementSelectNumber = () => {
  if (selectnumber.value > 1) {
    selectnumber.value--;
  }
};
const setSelectNumber = (value) => {
  selectnumber.value = value;
};
</script>
<template>
  <!-- <button @click="modalopensample">モーzダルを開く</button> -->
  <teleport to="body">
    <div v-if="goods_dialog" class="modal">
      <div class="modal_title">応援支援購入</div>
      <div class="inner" ref="modalInnerRef">
        <!-- クラウドファンディング用：リターン選択画面 -->
        <div v-show="firststep && campaignId">
          <div class="body">
            <div v-if="isLoadingReturns" class="loading-overlay">
              <div class="loading-message">ローディング中<span class="loading-dots"></span></div>
            </div>
            <div class="unit">
              <p class="textaline_center titlebold">リターンを選択</p>
              <div v-for="returnItem in returnItems" :key="returnItem.id" class="unit_outline">
                <div v-if="returnItem.thumbUrl" class="return-thumb">
                  <img :src="returnItem.thumbUrl" :alt="returnItem.title" />
                </div>
                <p class="textaline_margin">
                  <strong>{{ returnItem.title }}</strong
                  ><br />
                  価格: {{ new Intl.NumberFormat("ja-JP").format(returnItem.price) }}円<br />
                  <span v-if="returnItem.deliveryAt">お届け予定: {{ returnItem.deliveryAt }}</span
                  ><br />
                  <span v-if="returnItem.supporterCount"
                    >応援者数: {{ returnItem.supporterCount }}人</span
                  >
                </p>
                <div v-if="returnItem.description" class="textaline_margin">
                  <button class="detail-toggle-button" @click="toggleDescription(returnItem.id)">
                    {{ expandedDescriptions[returnItem.id] ? "詳細を閉じる▲" : "詳細を見る▼" }}
                  </button>
                  <p v-show="expandedDescriptions[returnItem.id]" class="return-description">
                    {{ returnItem.description }}
                  </p>
                </div>
                <p class="textaline_center margn_bottom_reset">
                  <button
                    class="normal next mt-3 mb-5"
                    @click="selectReturn(returnItem)"
                    :disabled="returnItem.isSoldOut"
                  >
                    {{ returnItem.isSoldOut ? "売り切れ" : "このリターンを選択" }}
                  </button>
                </p>
              </div>
            </div>
          </div>
          <div class="btn_conteiner">
            <button class="return" @click="dialogclose">閉じる</button>
          </div>
        </div>

        <!-- 従来のガチャ用：数量選択画面（後方互換性のため残す） -->
        <div v-show="firststep && !campaignId">
          <!-- <div class="body">
            <div class="unit">
              <p>購入数</p>
              <v-select :items="items" v-model="selectnumber"></v-select>
              <p class="textaline_right">
                <button class="normal" @click="openGoodsListDialog">グッズ一覧を見る</button>
              </p>
            </div>
          </div> -->
          <div class="body">
            <div class="unit">
              <p class="textaline_center titlebold">数量選択</p>
              <div class="number-selection">
                <div class="control-group">
                  <!-- 追加 -->
                  <div class="quantity-buttons">
                    <button class="quantity-button" @click="decrementSelectNumber()">-</button>
                  </div>
                  <p class="number-display">{{ selectnumber }}</p>
                  <div class="quantity-buttons">
                    <button class="quantity-button" @click="incrementSelectNumber()">+</button>
                  </div>
                </div>
                <div class="numberbox">
                  <div>
                    <p class="textaline_center mt-3">まとめ買い数量を選択</p>
                  </div>
                  <button class="preset-button" @click="setSelectNumber(5)">5回</button>
                  <button class="preset-button" @click="setSelectNumber(10)">10回</button>
                  <button class="preset-button" @click="setSelectNumber(20)">20回</button>
                  <button class="preset-button" @click="setSelectNumber(50)">50回</button>
                </div>
              </div>
              <p class="textaline_right mt-3">
                <button class="normal" @click="openGoodsListDialog">グッズ一覧を見る</button>
              </p>
            </div>
          </div>

          <div class="btn_conteiner">
            <button class="return" @click="dialogclose">閉じる</button>
            <button class="normal next" @click="confirmgoods">くじの購入へ進む</button>
          </div>
        </div>
        <div v-show="secondstep">
          <div class="body">
            <div v-if="loadingforaddress" class="loading-overlay">
              <div class="loading-message">ローディング中<span class="loading-dots"></span></div>
            </div>
            <div class="unit">
              <p class="textaline_center titlebold">お届け先住所を選択</p>
              <div v-for="(address, index) in addresseslocal" :key="index" class="unit_outline">
                <p class="textaline_margin">
                  〒{{ address.postNumber }}<br />
                  住所: {{ address.address01 }}<br />
                  {{ address.address02 }}<br />
                  氏名:{{ address.name }}<br />
                  電話番号: {{ address.phoneNumber }}
                </p>
                <p class="textaline_center margn_bottom_reset">
                  <button class="normal next mt-3 mb-5" @click="toSelectPayment(index)">
                    この住所に届ける
                  </button>
                </p>
              </div>
              <p class="textaline_center">
                <button class="normal next" @click="toAddAddress">+ お届け先を追加</button>
              </p>
            </div>
            <div class="btn_conteiner unit">
              <button class="return" @click="returnsteps(2)">戻る</button>
            </div>
          </div>
        </div>

        <div v-show="nextsecondstep">
          <div class="body">
            <div class="background">
              <p class="textaline_center titlebold">お届け先住所を追加</p>
              <div class="field">
                <p class="title">郵便番号</p>
                <input
                  type="text"
                  v-model="postcode"
                  @input="getaddressfrompostcode"
                  required
                  class="inputpostcode"
                />
                <p class="attention">※郵便番号を入力すると住所は自動で入力されます</p>
                <p class="error" v-if="postcodeError">{{ postcodeError }}</p>
              </div>
              <div class="field">
                <p class="title">都道府県</p>
                <input type="text" v-model="todohuken" required class="inputtodohuken" />
              </div>
              <div class="field">
                <p class="title">ご住所</p>
                <input type="text" v-model="moreaddress" required class="inputaddress" />
              </div>
              <div class="field">
                <p class="title">建物名・<br />部屋番号</p>
                <input type="text" v-model="address2" required class="inputaddress" />
              </div>
              <div class="field">
                <p class="title">姓</p>
                <input type="text" v-model="familyname" required class="inputname" />
              </div>
              <div class="field">
                <p class="title">名</p>
                <input type="text" v-model="firstname" required class="inputname" />
              </div>
              <div class="field">
                <p class="title">電話番号</p>
                <input
                  type="text"
                  v-model="phoneno"
                  @input="checkphoneno"
                  required
                  class="inputname"
                />
                <p class="error" v-if="phoneError">{{ phoneError }}</p>
              </div>
              <div class="btn_conteiner unit">
                <button class="return" @click="returnsteps(2.5)">キャンセル</button>
                <button class="normal next" @click="sendaddress()">お届け先住所を追加</button>
              </div>
            </div>
          </div>
        </div>

        <div v-show="thirdstep">
          <div class="body">
            <div class="unit">
              <p class="textaline_center titlebold">決済方法を選択</p>
              <button class="list next" block @click="selectCreditCardPayment">
                クレジットカード
              </button>
              <!-- <button class="list" block @click="selectCarrierPayment">
                スマートフォンキャリア決済
              </button> -->
              <!-- <button class="paidy" @click="selectPaidyPayment">
                あと払い（ペイディ）
                <img src="img/paidy.png" alt="Paidy" class="paidy-icon" />
              </button> -->
              <button class="list boxtitleforpaidy mt-3" block @click="selectPaidyPayment">
                あと払い（ペイディ）
                <img src="/img/paidy_white.png" alt="Paidy" class="paidy-icon" />
              </button>
            </div>
            <div class="btn_conteiner unit">
              <button class="return" @click="returnsteps(3)">戻る</button>
            </div>
          </div>
        </div>
        <div v-show="fourthstep">
          <v-progress-circular
            v-if="isLoadingforcredit == true"
            indeterminate
            color="purple"
          ></v-progress-circular>
          <div class="body">
            <div class="unit">
              <p class="textaline_center titlebold">クレジットカードを選択</p>
              <div class="unit_outline" v-for="(card, index) in productsInfoLocal" :key="index">
                <p class="textaline_margin">
                  カードブランド:
                  <span v-if="card.card.brand === 'visa'">Visa</span>
                  <span v-else-if="card.card.brand === 'mastercard'">Mastercard</span>
                  <span v-else-if="card.card.brand === 'amex'">American Express</span>
                  <span v-else-if="card.card.brand === 'jcb'">JCB</span>
                  <span v-else-if="card.card.brand === 'diners'">Diners Club</span>
                  <span v-else>{{ card.card.brand }}</span>
                  <br />
                  カード番号下4桁: {{ card.card.last4 }}<br />
                  有効期限: {{ card.card.exp_month }}/ {{ card.card.exp_year }}<br />
                </p>
                <p class="textaline_center margn_bottom_reset">
                  <button class="normal next mt-3 mb-5" @click="toComfirmOrderUsingCard(index)">
                    このカードを使用する
                  </button>
                </p>
              </div>
            </div>
            <div class="btn_conteiner unit">
              <button class="normal next" @click="toAddCard">+ クレジットカードを追加</button>
            </div>
            <div class="btn_conteiner unit">
              <button class="return" @click="returnsteps(4)">戻る</button>
            </div>
          </div>
        </div>

        <div v-show="nextfourthstep">
          <div v-if="loadingforaddcardload" class="loading-overlay">
            <div class="loading-message">ローディング中<span class="loading-dots"></span></div>
          </div>
          <MainAddCardDialog
            @addcardclose="addcardclose"
            @addcardload="addcardload"
            @addcardloadoff="addcardloadoff"
          />
        </div>

        <div v-show="fifthstep">
          <div class="body">
            <!-- ローディング表示 -->
            <div v-if="loading" class="loading-overlay">
              <div class="loading-message">ローディング中<span class="loading-dots"></span></div>
            </div>
            <!-- 決済処理中のローディング表示 -->
            <div v-if="isSubmittingSupport" class="loading-overlay">
              <div class="loading-message">決済処理中<span class="loading-dots"></span></div>
            </div>
            <!-- クラウドファンディング用：支援確認画面 -->
            <template v-if="campaignId && selectedReturn">
              <h3 class="textaline_center mt-2 mb-5">支援内容の確認</h3>
              <div v-show="carderror" class="unit">
                <p class="error">
                  この支援はエラーにて完了しておりません。<br />クレジットカード決済の方は別のクレジットカードにて再度ご支援をお願いします。
                  <span v-if="error">（{{ error }}）</span>
                </p>
              </div>
              <div v-show="paidyfronterror" class="unit">
                <p class="error">
                  あと払い（ペイディ）の決済に失敗しました。<br />もう一度お試しいただくか、別の決済方法をお選びください。
                </p>
              </div>
              <div class="unit">
                <dl class="price">
                  <dt>リターン</dt>
                  <dd>{{ selectedReturn.title }}</dd>
                </dl>
                <dl class="price">
                  <dt>支援金額</dt>
                  <dd>￥ {{ new Intl.NumberFormat("ja-JP").format(selectedReturn.price) }}円</dd>
                </dl>
              </div>
              <!-- 配送が必要な場合、またはpaidy決済の場合に住所を表示 -->
              <div v-if="requiresShippingAddress || usepaidypaymentflag" class="unit">
                <p class="textaline_center titlebold mt-6">お届け先住所</p>
                <div v-if="chooseaddress" class="unit_outline">
                  <p class="textaline_margin">
                    〒{{ chooseaddress.postNumber }}<br />
                    住所: {{ chooseaddress.address01 }}<br />
                    {{ chooseaddress.address02 }}<br />
                    氏名: {{ chooseaddress.name }}<br />
                    電話番号: {{ chooseaddress.phoneNumber }}
                  </p>
                  <div class="textaline_right mb-2">
                    <button @click="changeAddress">▶︎住所を変更</button>
                  </div>
                </div>
                <div v-else class="unit_outline">
                  <p class="error">住所が選択されていません</p>
                  <div class="textaline_right mb-2">
                    <button @click="changeAddress">▶︎住所を選択</button>
                  </div>
                </div>
              </div>
              <div class="unit">
                <p class="textaline_center titlebold mt-3">支払い方法</p>
                <div v-if="usepaidypaymentflag" class="unit_outline">
                  <p class="textaline_margin">
                    あと払い（ペイディ）
                    <img src="/img/paidy.png" alt="Paidy" class="paidy_paymentway" />
                  </p>
                  <div class="textaline_right mb-2">
                    <button @click="changePayment">▶︎支払い方法を変更</button>
                  </div>
                </div>
                <div v-else-if="choosecard && choosecard.card" class="unit_outline">
                  <p class="textaline_margin">
                    カードブランド:
                    <span v-if="choosecard.card.brand === 'visa'">Visa</span>
                    <span v-else-if="choosecard.card.brand === 'mastercard'">Mastercard</span>
                    <span v-else-if="choosecard.card.brand === 'amex'">American Express</span>
                    <span v-else-if="choosecard.card.brand === 'jcb'">JCB</span>
                    <span v-else-if="choosecard.card.brand === 'diners'">Diners Club</span>
                    <span v-else>{{ choosecard.card.brand }}</span>
                    <br />
                    カード番号下4桁: {{ choosecard.card.last4 }}<br />
                    有効期限: {{ choosecard.card.exp_month }}/{{ choosecard.card.exp_year }}<br />
                  </p>
                  <div class="textaline_right mb-2">
                    <button @click="changePayment">▶︎支払い方法を変更</button>
                  </div>
                </div>
                <div v-else class="unit_outline">
                  <p class="textaline_margin">決済方法が選択されていません</p>
                  <div class="textaline_right mb-2">
                    <button @click="changePayment">▶︎支払い方法を選択</button>
                  </div>
                </div>
              </div>
              <div class="unit">
                <label class="form-label">応援メッセージ（任意）</label>
                <textarea
                  v-model="supportMessage"
                  class="message-input"
                  rows="4"
                  placeholder="応援メッセージを入力してください"
                  maxlength="500"
                ></textarea>
                <p class="character-count">{{ supportMessage.length }}/500</p>
                <p class="message-note">
                  ※ご記載いただいた応援メッセージは、プロジェクトページとコメントへ投稿されます。
                </p>
                <!-- エラーメッセージ表示 -->
                <div v-if="carderror && error" class="unit" style="margin-top: 10px">
                  <p class="error">
                    この支援はエラーにて完了しておりません。<br />クレジットカード決済の方は別のクレジットカードにて再度ご支援をお願いします。<br />
                    <span v-if="error">（{{ error }}）</span>
                  </p>
                </div>
                <div v-if="paidyfronterror" class="unit" style="margin-top: 10px">
                  <p class="error">
                    あと払い（ペイディ）の決済に失敗しました。<br />もう一度お試しいただくか、別の決済方法をお選びください。
                  </p>
                </div>
              </div>
            </template>
            <!-- 従来のガチャ用：くじ購入の確認（後方互換性のため残す） -->
            <template v-else>
              <h3 class="textaline_center mt-2 mb-5">くじ購入の確認</h3>
              <div v-show="carderror">
                <p class="error">
                  この購入はエラーにて完了しておりません。<br />クレジットカード決済の方は別のクレジットカードにて再度ご購入をお願いします。
                </p>
              </div>
              <div v-show="paidyfronterror">
                <p class="error">
                  あと払い（ペイディ）の決済に失敗しました。<br />もう一度お試しいただくか、別の決済方法をお選びください。
                </p>
              </div>
              <div class="btn_conteiner unit">
                <button class="normal next" @click="comfirmBuy()">注文を確定する</button>
              </div>
              <div class="unit">
                <dl class="price">
                  <dt>購入数</dt>
                  <dd>{{ selectnumber }}</dd>
                </dl>
              </div>
              <div class="unit">
                <dl class="price">
                  <dt>商品の小計</dt>
                  <dd>￥ {{ sumPrice }}円（税込）</dd>
                </dl>
                <dl class="price">
                  <dt>配送料</dt>
                  <dd>￥{{ shippingFee }}円（税込・20回ごとに送料がかかります</dd>
                </dl>
                <dl class="price">
                  <dt>合計</dt>
                  <dd>￥ {{ totallPrice }}</dd>
                </dl>
              </div>

              <div class="unit">
                <p class="textaline_center titlebold mt-6">お届け先住所</p>
                <div class="unit_outline">
                  <p class="textaline_margin">
                    〒{{ chooseaddress.postNumber }}<br />
                    住所: {{ chooseaddress.address01 }}<br />
                    {{ chooseaddress.address02 }}<br />
                    氏名: {{ chooseaddress.name }}<br />
                    電話番号: {{ chooseaddress.phoneNumber }}
                  </p>
                  <div class="textaline_right mb-2">
                    <button @click="changeAddress">▶︎住所を変更</button>
                  </div>
                </div>
              </div>
              <p class="textaline_center titlebold mt-3">支払い方法</p>
              <div v-if="usecarrierpaymentflag" class="unit_outline">
                <p>スマートフォンキャリア決済</p>
                <button @click="changePayment">▶︎支払い方法を変更</button>
              </div>
              <div v-if="usepaidypaymentflag" class="unit_outline">
                <p class="textaline_margin">
                  あと払い（ペイディ）
                  <img src="/img/paidy.png" alt="Paidy" class="paidy_paymentway" />
                </p>
                <div class="textaline_right mb-2">
                  <button @click="changePayment">▶︎支払い方法を変更</button>
                </div>
              </div>
              <div v-else class="unit_outline">
                <p v-if="choosecard && choosecard.card" class="textaline_margin">
                  カードブランド:
                  <span v-if="choosecard.card.brand === 'visa'">Visa</span>
                  <span v-else-if="choosecard.card.brand === 'mastercard'">Mastercard</span>
                  <span v-else-if="choosecard.card.brand === 'amex'">American Express</span>
                  <span v-else-if="choosecard.card.brand === 'jcb'">JCB</span>
                  <span v-else-if="choosecard.card.brand === 'diners'">Diners Club</span>
                  <span v-else>{{ choosecard.card.brand }}</span>
                  <br />
                  カード番号下4桁: {{ choosecard.card.last4 }}<br />
                  有効期限: {{ choosecard.card.exp_month }}/{{ choosecard.card.exp_year }}<br />
                </p>
                <p v-else>カードが選択されていません。</p>
                <div class="textaline_right mb-2">
                  <button @click="changePayment">▶︎支払い方法を変更</button>
                </div>
              </div>

              <div class="btn_conteiner unit">
                <button class="normal next" @click="comfirmBuy()">注文を確定する</button>
              </div>
            </template>
            <div class="btn_conteiner unit" v-if="campaignId && selectedReturn">
              <button
                class="normal next"
                @click="comfirmCrowdfundingSupport()"
                :disabled="isSubmittingSupport"
              >
                {{ isSubmittingSupport ? "処理中..." : "支援を確定する" }}
              </button>
            </div>
            <div class="btn_conteiner unit">
              <button class="return" @click="returnsteps(6)">戻る</button>
            </div>
          </div>
        </div>

        <div v-show="sixstep">
          <div class="body">
            <!-- クラウドファンディング用：支援完了画面 -->
            <template v-if="campaignId && selectedReturn">
              <h3 class="resutltitle">ご支援ありがとうございました！</h3>
              <div class="unit">
                <p class="textaline_center">
                  ご支援いただいた内容<br />
                  <strong>{{ selectedReturn.title }}</strong
                  ><br />
                  支援金額: {{ new Intl.NumberFormat("ja-JP").format(selectedReturn.price) }}円
                </p>
                <p class="textaline_center mt-3">
                  ご支援いただいた内容は、プロジェクトの成功に向けて大切に活用させていただきます。
                </p>
              </div>
              <div class="btn_conteiner unit">
                <button class="return" @click="dialogclose">閉じる</button>
              </div>
            </template>
            <!-- 従来のガチャ用：当選結果（後方互換性のため残す） -->
            <template v-else>
              <!-- ローディング表示 -->
              <div v-if="isLoadingforvideo" class="loading-overlay">
                <div class="loading-message">ローディング中<span class="loading-dots"></span></div>
              </div>
              <div v-if="loadingForOrder" class="loading-overlay">
                <div class="loading-message">ローディング中<span class="loading-dots"></span></div>
              </div>
              <h3 class="resutltitle">当選結果</h3>
              <!-- ローディング中にセージを隠すために追加 -->
              <div v-if="isLoadingforvideo">
                <div style="min-height: 100px"></div>
              </div>
              <div class="unit">
                <div
                  v-if="
                    order != null && videoplayflag == true && order[productindex].product_movie == 1
                  "
                >
                  <video
                    class="gacha_movie"
                    :src="gachaVideoUrlA"
                    autoplay
                    muted
                    playsinline
                    @loadeddata="handleLoadedData"
                    @play="handlePlay"
                    @ended="videoend"
                  ></video>
                </div>

                <div
                  v-if="
                    order != null && videoplayflag == true && order[productindex].product_movie == 2
                  "
                >
                  <video
                    class="gacha_movie"
                    :src="gachaVideoUrlB"
                    autoplay
                    muted
                    playsinline
                    @loadeddata="handleLoadedData"
                    @play="handlePlay"
                    @ended="videoend"
                  ></video>
                </div>
                <div
                  v-if="
                    order != null && videoplayflag == true && order[productindex].product_movie == 3
                  "
                >
                  <video
                    class="gacha_movie"
                    :src="gachaVideoUrlC"
                    autoplay
                    muted
                    playsinline
                    @loadeddata="handleLoadedData"
                    @play="handlePlay"
                    @ended="videoend"
                  ></video>
                </div>

                <div
                  class="gacha_result"
                  v-if="order != null && showimageflag == true && dataLenght > productindex"
                >
                  <p class="image"><img :src="order[productindex].product_image" /></p>
                  <p class="name">{{ order[productindex].product_name }}</p>
                  <p class="rank">{{ order[productindex].product_rank_ja }}</p>
                  <div class="unit textaline_center">
                    <button class="normal next" @click="nextproduct">次のくじを引く</button>
                    <button class="normal" @click="toAllproducts">スキップして結果一覧へ</button>
                  </div>
                </div>

                <div
                  class="gacha_result"
                  v-if="order != null && showimageflag == true && dataLenght == productindex"
                >
                  <p class="image"><img :src="order[productindex].product_image" /></p>
                  <p class="name">{{ order[productindex].product_name }}</p>
                  <p class="rank">{{ order[productindex].product_rank_ja }}</p>
                  <div class="unit textaline_center">
                    <button class="normal" @click="toAllproducts">結果へ進む</button>
                  </div>
                </div>

                <div class="productcontainer" v-if="allproductsflag">
                  <!-- 全ての商品を表示 -->
                  <div class="subproductcontaine" v-for="(val, key) in order" :key="key">
                    <img class="productpic" :src="val['product_image']" />
                    <p class="productrank">{{ val["product_rank_ja"] }}</p>
                    <p class="productname">{{ val["product_name"] }}</p>
                  </div>
                  <div
                    class="btn_conteiner"
                    style="width: 100%; display: flex; justify-content: center"
                  >
                    <button class="return" @click="dialogclose">閉じる</button>
                  </div>
                </div>
                <!-- 
              <div v-show="isDeclinePayment">
                <h2>
                  決済に失敗しました。支払い方法を変更するか、別のクレジットカードをご使用ください。
                </h2>
              </div> -->
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <GoodsListDialog
    :GoodsListDialogflag="GoodsListDialogflag"
    :goodsData="goodsData"
    @goodslistdialogclose="goodslistdialogclose"
  />
</template>

<style scoped>
.modal {
  position: absolute;
  bottom: 0;
  background-color: #ffffff;
  width: 100%;
  border-radius: 15px 15px 0 0;
  box-shadow: 0px -10px 10px -5px rgba(0, 0, 0, 0.6);
  z-index: 100;
  touch-action: manipulation; /* モバイルでの拡大を禁止 */
  zoom: 1; /* ブラウザでの拡大を禁止 */
}
.modal .modal_title {
  width: 100%;
  padding: 12px 15px 10px 15px;
  text-align: center;
  font-size: 1rem;
  background: rgb(240, 172, 196);
  color: #ffffff;
  line-height: 1.2em;
  border-radius: 15px 15px 0 0;
  border-top: solid 1px rgb(255, 255, 255, 0.3);
}
.modal .inner {
  overflow: scroll;
  max-height: 200px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.modal .body {
  padding: 0px 15px;
  font-size: 0.9rem;
  line-height: 1.5em;
}
.modal .body .unit {
  margin-bottom: 15px;
}
.modal .body p {
  margin-bottom: 10px;
}

.modal .body select {
  width: 100%;
  height: 40px;
  border: none;
  border-bottom: #666 solid 2px;
  background-color: #eeeeee;
  padding: 15px 10px;
  border-radius: 0;
  font-size: 1rem;
}
.modal .btn_conteiner {
  text-align: center;
}
.modal button.normal,
.modal button.return {
  padding: 10px 15px;
  font-size: 0.9rem;
  border-radius: 100px;
  border: none;
  margin: 0 5px;
  background: rgb(240, 172, 196);
  color: #ffffff;
}
.modal button.normal:active {
  background: rgb(240, 172, 196);
}
.modal button.normal:disabled {
  background: #cccccc;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.6;
}
.modal button.return {
  background: rgb(226, 226, 226);
  color: rgb(142 144 147);
}
.modal button.return:active {
  background: rgb(190, 190, 190);
  color: rgb(255 255 255);
}
.modal button.list {
  width: 100%;
  text-align: center;
  padding: 10px 15px;
  font-size: 0.9rem;
  border: none;
  background: rgb(240, 172, 196);
  color: #ffffff;
  border-bottom: solid 1px rgb(132, 163, 206);
}
.modal button.list:active {
  background: rgb(240, 172, 196);
}
.modal .unit_outline {
  background-color: #f5f5f5;
  border-radius: 20px;
  border: solid 1px rgb(226, 226, 226);
  padding: 15px 10px 1px 10px;
  margin-bottom: 30px;
  font-size: 16px;
}
.next {
  background: rgb(218, 57, 144) !important;
}
.boxtitleforpaidy {
  background: rgb(166, 0, 156) !important;
}
.textaline_center {
  text-align: center;
}
.textaline_left {
  text-align: left;
}
.textaline_right {
  text-align: right;
}
.margn_bottom_reset {
  margin-bottom: 0 !important;
}

/*アドレス追加用  */
.field {
  margin: 0 0 10px;
  vertical-align: middle;
}

.inputpostcode,
.inputtodohuken,
.inputaddress,
.inputname {
  font-size: 1rem;
  margin: 0 0 0 0px;
  outline: 1px solid;
  padding: 8px;
  border: none;
  border-bottom: #666 solid 1px;
  background-color: #eeeeee;
  outline: none;
  vertical-align: middle;
}
.inputpostcode {
  width: 100px;
}
.inputtodohuken {
  width: 100px;
}
.inputaddress {
  width: 250px;
}
.inputname {
  width: 150px;
}

.field .title {
  font-size: 0.8rem;
  display: inline-block;
  width: 80px;
  vertical-align: middle;
  margin: 0 !important;
}
dl.price {
  display: flex;
  margin: 10px 0;
}
dl.price dt {
  width: 50%;
  border-bottom: solid 1px #aaa;
  padding-bottom: 5px;
}
dl.price dd {
  width: 50%;
  text-align: right;
  border-bottom: solid 1px #aaa;
  padding-bottom: 5px;
}
.dialogtitle {
  margin: 0 0 0 0;
  /* padding: 0.5em 1em; */
  background: #fff;
  border: solid 1px;
  border-radius: 10px 10px 0 0; /*角の丸み*/
  background-color: rgb(142 144 147);
}

.background {
  /* background-color: white;
  width: 300px; */
}
.bottonconteiner {
  margin: 50px 0 20px 0;
  display: flex;
}
.addaddress {
  color: rgb(255 255 255);
  font-size: 10px;
}

.return {
  color: rgb(142 144 147);
  font-size: 12px;
}
.gacha_movie {
  width: 100%;
}
.gacha_result {
}
.gacha_result .image {
  text-align: center;
}
.gacha_result .image img {
  width: 50%;
  max-width: 200px;
  height: auto;
  object-fit: contain;
}
.gacha_result .name {
  text-align: center;
}
.gacha_result .rank {
  text-align: center;
}
.productcontainer {
  display: flex;
  /*コレ*/
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.subproductcontaine {
  border: 1px solid rgb(216, 216, 216);
  padding: 10px;
  margin: 10px 1.5% 10px 1.5%;
  width: 30%;
  text-align: center;
  border-radius: 8px;
}
.productpic {
  width: 100%;
  max-width: 150px;
  height: auto;
  object-fit: contain;
  margin-bottom: 0.7em;
}
.productname {
  font-size: 0.8rem;
}
.productrank {
  font-size: 0.8rem;
}
.modal .btn_conteiner {
  display: flex;
  justify-content: center;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.5); /* 半透明の灰色背景色 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* 追加：z-indexプロパティ */
}

.body {
  font-family: Arial, sans-serif;
  padding: 20px;
}

.unit {
  margin-bottom: 20px;
}

.number-selection {
  display: flex;
  align-items: center;
}

.quantity-input {
  display: inline-block;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: #f5f5f5;
  cursor: pointer;
}

.quantity-input-field {
  display: inline-block;
}

.quantity-input-field input {
  width: 40px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.quantity-input-field-placeholder {
  display: inline-block;
  color: #999;
  cursor: pointer;
}

.quantity-buttons {
  display: flex;
  margin-left: 10px;
}

.quantity-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  background-color: #f5f5f5;
  cursor: pointer;
}

.quantity-button:focus {
  outline: none;
}

.textaline_right {
  text-align: right;
}

.error {
  color: red;
  font-size: 10px;
}

.number-display {
  border: 3px solid black;
  padding: 10px;
  display: inline-block;
  text-align: center;
  width: 100px;
  height: 50px;
}

.quantity-button {
  margin: 0 5px; /* 0は上下のマージン、10pxは左右のマージン */
  width: 50px; /* ボタンの幅 */
  height: 50px; /* ボタンの高さ */
}
.number-selection {
  display: flex;
  flex-direction: column;
  /* align-items: flex-start; */
}

.control-group {
  /* 追加 */
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.quantity-buttons {
  display: flex;
}

.preset-buttons {
  display: flex;
  justify-content: flex-start;
}
.preset-button {
  background-color: rgb(226, 226, 226);
  padding: 5px; /* ボタン内のスペース */
  margin: 5px; /* ボタン間のスペース */
  border-radius: 5px; /* ボタンの角丸 */
  width: 50px;
}
.titlebold {
  font-weight: bold;
}
.textaline_margin {
  margin-left: 15px;
}
@keyframes ellipsis {
  0% {
    content: " .  ";
  }
  33% {
    content: " .. ";
  }
  67% {
    content: " ...";
  }
  100% {
    content: "    ";
  }
}

.loading-message {
  color: white; /* 白色の文字色 */
  font-size: 24px;
  font-weight: bold;
}

.loading-dots::after {
  content: "";
  display: inline-block;
  width: 1em;
  animation: ellipsis 2s infinite;
  color: white; /* 白色の文字色 */
}
.attention {
  font-size: 8px;
}
.resutltitle {
  text-align: center;
}

.paidy-icon {
  height: 20px; /* アイコンの高さを調整 */
  margin-left: 8px; /* テキストとの間隔を調整 */
}

.paidy_paymentway {
  height: 35px; /* アイコンの高さを調整 */
  /* margin-left: 3px; テキストとの間隔を調整 */
}

/* クラウドファンディング用スタイル */
.return-thumb {
  width: 100%;
  margin-bottom: 10px;
}

.return-thumb img {
  width: 100%;
  max-width: 300px;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.return-description {
  font-size: 0.9rem;
  color: #666;
  margin-top: 10px;
  line-height: 1.5;
}

.detail-toggle-button {
  background: none;
  border: none;
  color: rgb(240, 172, 196);
  font-size: 0.9rem;
  cursor: pointer;
  padding: 5px 0;
  text-decoration: underline;
  margin-top: 5px;
}

.detail-toggle-button:hover {
  color: rgb(218, 57, 144);
}

.message-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
}

.character-count {
  text-align: right;
  font-size: 0.85rem;
  color: #999;
  margin-top: 0.25rem;
}

.message-note {
  font-size: 0.85rem;
  color: #666;
  margin-top: 0.5rem;
  line-height: 1.4;
}

.form-label {
  display: block;
  font-size: 1rem;
  font-weight: bold;
  text-align: left;
  color: #333;
  margin-bottom: 0.5rem;
}

@media (min-width: 960px) {
  .modal {
    width: 48%;
    height: 400px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-2%, -50%);
    border-radius: 15px;
  }
  .modal .inner {
    max-height: 300px;
    overflow: auto;
  }
  .unit_outline {
    background-color: #f5f5f5;
    border-radius: 20px;
    border: solid 1px rgb(226, 226, 226);
    padding: 15px 20px 10px 20px;
    margin-bottom: 30px;
    margin-left: 15%;
    margin-right: 15%;
    font-size: 16px;
  }
}
</style>
